module.exports = __webpack_public_path__ + "img/play@2x.f2372978.png";